import {subSeconds} from 'date-fns'
import type {OmitStrict} from 'type-zoo'
import type {
  TAdminSignUpRequestData,
  TAdminSignUpsResponse,
} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import {
  mkISOTimestamp,
  mkPlayerEmail,
  mkPlayerUsername,
  mkSignupRequestId,
} from '@kapitalist/contract/types'
import {GetApi} from '~/api/client'

export type TAdminSignUpsResult = OmitStrict<
  TAdminSignUpsResponse,
  'signupRequests'
> & {
  signupRequests: Array<
    OmitStrict<TAdminSignUpRequestData, 'createdAt'> & {
      createdAt: Date
    }
  >
}

const endpoint = endpoints.admin.listSignUps

export default class AdminSignUps extends GetApi<
  typeof endpoint,
  TAdminSignUpsResult
>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(): TAdminSignUpsResponse {
    return {
      signupRequests: AdminSignupsMock,
    }
  }

  protected transformResponse(r: TAdminSignUpsResponse): TAdminSignUpsResult {
    return transformAdminSignUpsResponse(r)
  }
}

export const transformAdminSignUpsResponse = (
  r: TAdminSignUpsResponse
): TAdminSignUpsResult => {
  return {
    ...r,
    signupRequests: r.signupRequests.map(sr => ({
      ...sr,
      createdAt: new Date(sr.createdAt),
    })),
  }
}

export const AdminSignupsMock: TAdminSignUpRequestData[] = [
  {
    id: mkSignupRequestId('456'),
    email: mkPlayerEmail('monroe456@example.com'),
    createdAt: mkISOTimestamp(new Date().toISOString()),
    username: mkPlayerUsername('monroe456'),
  },
  {
    id: mkSignupRequestId('123'),
    email: mkPlayerEmail('monroe123@example.com'),
    createdAt: mkISOTimestamp(subSeconds(new Date(), 90).toISOString()),
    username: mkPlayerUsername('monroe123'),
  },
]
